#import "../../LookupAccountFields.graphql"
mutation LookupAccountUpdate($input: LookupAccountUpdateInput!) {
  lookupAccountUpdate(input: $input) {
    lookupAccount {
      ...LookupAccountFields
    }
  }
}
